export const STUDY_FORM_OPTION_KEYS = [
  { value: 'Daily', labelKey: 'Daily' },
  { value: 'External', labelKey: 'External' },
];

export const STUDENT_STATE_OPTION_KEYS = [
  { value: 'Active', labelKey: 'Active' },
  { value: 'Finished', labelKey: 'Finished' },
  { value: 'Interrupted', labelKey: 'Interrupted' },
  { value: 'Expelled', labelKey: 'Expelled' },
];

export const CONCLUSION_OPTION_KEYS = [
  { value: 'Continue', labelKey: 'Pokračovať' },
  { value: 'ContinueExtended', labelKey: 'Pokračovať (predĺžené)' },
  { value: 'End', labelKey: 'Ukončiť' },
  { value: 'Expulsion', labelKey: 'Vylúčiť' },
];

export const translateOptions = (options, t) =>
  options.map((option) => ({
    value: option.value,
    label: t(option.labelKey),
  }));
